export default __webpack_public_path__ + "static/balance_2-47ff9910f02b4159df05c873b7b15c7c.jpg";